import { axiosApi } from "../../../../../api/dbAxios";

export type NewRoleItem = {
  name: string | null;
  email: string;
  right_id: number | string;
  team_id: number | null;
};

export const addNewUser = async (items: NewRoleItem[]) => {
  const body = items.map((u) => ({
    team: u.team_id !== null ? String(u.team_id) : null,
    right_id: Number(u.right_id),
    user: {
      name: u.name,
      email: u.email,
    },
  }));

  try {
    const response = await axiosApi.post(`/roles/`, body);
    return response.data;
  } catch (error) {
    console.error("Error adding new User:", error);
    throw error;
  }
};
